/**
 * @hook useFeatureFlags
 * @description Reactive shell for the FeatureOrchestrator.
 */
import { useEffect, useState } from 'react';
import { FeatureOrchestrator } from './FeatureOrchestrator';

export const useFeatureFlags = () => {
  const [flags, setFlags] = useState(() => 
    FeatureOrchestrator.getInitialState()
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refs = { isMounted: true };
    
    FeatureOrchestrator.syncFlags(setFlags, setLoading, refs);

    return () => { refs.isMounted = false; };
  }, []);

  return { flags, loading };
};